import { Chart } from '@antv/g2';
import React, { useEffect } from 'react';

let chartInstance = null;

const ActiveAccountsChart = ({ accounts }) => {
  const activeAccountsChart = () => {

    let percent = Math.round((accounts?.new_actives / accounts?.actives) * 100);

    const data = [
      {
        type: `+${percent}%`,
        percent: percent,
        color: '#6950E8' },
    ];

    if (chartInstance) {
      chartInstance.destroy();
    }

    const chart = new Chart({
      container: 'active-accounts-chart',
      autoFit: true,
      height: 150,
      width: 150
    });

    chartInstance = chart;

    const facetRect = chart
      .facetRect()
      .data(data)
      .encode('x', 'type')
      .axis(false)
      .legend(false)
      .view()
      .attr('frame', false)
      .coordinate({ type: 'theta', innerRadius: 0.5, outerRadius: 0.8 });

    facetRect
      .interval()
      .encode('y', 100)
      .scale('y', { zero: true })
      .style('fill', '#e8e8e8')
      .tooltip(false)
      .animate(false);

    facetRect
      .interval()
      .encode('y', 'percent')
      .encode('color', 'color')
      .scale('color', { type: 'identity' })
      .tooltip((data) => ({
        name: 'Cuentas activas',
        value: `+ ${accounts?.new_actives}`,
      }))
      .animate('enter', { type: 'waveIn', duration: 1000 });

    facetRect
      .text()
      .encode('text', 'type')
      .style('textAlign', 'center')
      .style('textBaseline', 'middle')
      .style('fontSize', 15)
      .style('color', '#8c8c8c')
      .style('x', '50%')
      .style('y', '50%')
      .tooltip(false);

    chart.render();
  }

  useEffect(() => {
    if(accounts !== undefined)
      activeAccountsChart();
  }, [accounts]);
  return (
    <div id="active-accounts-chart"></div>
  )
}

export default ActiveAccountsChart;